import { useState, useEffect, useCallback } from 'react';
import { portfolioAPI } from '../services/api';

export const usePortfolio = () => {
    const [projects, setProjects] = useState([]);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProjects = useCallback(async () => {
        setLoading(true);
        setError(null);
        
        try {
            const data = await portfolioAPI.getProjects(0, 50);
            setProjects(data);
        } catch (err) {
            setError('Erro ao carregar projetos');
            console.error('Error fetching projects:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchStats = useCallback(async () => {
        try {
            const data = await portfolioAPI.getStats();
            setStats(data);
        } catch (err) {
            console.error('Error fetching stats:', err);
        }
    }, []);

    useEffect(() => {
        fetchProjects();
        fetchStats();
    }, [fetchProjects, fetchStats]);

    return {
        projects,
        stats,
        loading,
        error,
        refetch: fetchProjects,
    };
};
